import React, { Fragment } from "react";
import styled from "styled-components";
import { Route, Link, NavLink } from "react-router-dom";
import { Button, Grid } from "@material-ui/core";
import { Done, Lock, Clear, Reply, AttachFile, InsertDriveFile, Create, Apps } from "@material-ui/icons";
import AddEditAlert from "components/Notifications/AddEditAlert";

/*
 * Removed in lieu of title class
 * const SectionTitle = styled.div`
 *   font-size: 24px;
 * `;
 */

const BlueButton = styled(Button)`
  &&{
    color:#2196f3
    padding: 8px 16px 8px 16px;
    :hover {
        background-color: rgba(0,0,0,0);
    }
  }
`;

const NewButton = styled(Button)`
  && {
    margin-left: 4px;
    padding: 8px 8px 8px 2px;
    border-radius: 0;
    color: #2196f3;
    background: none;
    position: unset;
  }
  &&:hover {
    background: none;
  }
`;

const NewLockedButton = styled(Button)`
&& {
  margin-left: 4px;
  padding: 8px 8px 8px 2px;
  border-radius: 0;
  color: #888888;
  background: none;
}
& span {
  margin-left: 4px;
}
&&:hover {
  background: #f6f6f6;
}
`;
const StyledSaveButton = styled(Button)`
  && {
    margin-left: 4px;
    padding: 7px 16px 7px 8px;
    border-radius: 0;
    color: rgb(255, 255, 255);
    background-color: rgba(0, 157, 223, 1);
  }
  &&:hover {
    background: rgba(0, 157, 223, 1);
  }
`;
export const VerticalDivider = styled.div`
  height: 24px;
  border-right: 1px solid #cccccc;
`;
const Container = styled.div`
  padding: 5px;
  border-width: 0px;
  height: 76px;
  background: inherit;
  background-color: rgba(255, 255, 255, 1);
  border: none;
  border-radius: 0px;
  -moz-box-shadow: none;
  -webkit-box-shadow: none;
  box-shadow: none;
`;

const NoteAttachmentContainer = styled(Grid)`
  width:auto !important;
  float:right !important;
`;

const SaveButton = props => (
  <StyledSaveButton name="saveButton" variant="contained" onClick={props.onClick}>
    <Done />
    SAVE
  </StyledSaveButton>
);

const CancelButton = props => (
  <NewButton name="cancelButton" variant="contained" onClick={props.onClick} disableRipple>
    <Clear />
    CANCEL
  </NewButton>
);
const AttachmentsButton = props => (
  <NewButton name="attachmentsButton" variant="contained" onClick={props.onClick} disableRipple>
    <AttachFile />
    ATTACHMENTS
  </NewButton>
);
const NotesButton = props => (
  <NewButton name="notesButton" variant="contained" onClick={props.onClick} disableRipple>

    <InsertDriveFile />
    NOTES
  </NewButton>
);

const EditButton = props => (
  <NewButton
    id="editButton"
    variant="contained"
    onClick={props.onClick}
    disableRipple
  >
    <Create />
    EDIT DEAL
  </NewButton>
);

const AddAlertButton = props => {
  const isEnabled = (
    (
      !props.guestPermissions ||
      (props.guestPermissions && !props.authentication.isGuest)
    ) &&
    props.parent &&
    props.parent.isProTier());
  if (isEnabled) {
    return (
      <NewButton onClick={props.action} disableRipple>
        ALERTS
      </NewButton>
    );
  }

  return (
    <NewLockedButton onClick={props.parent.openPopup} disableRipple>
      <Lock />
      ALERTS
    </NewLockedButton>
  );
};

const SetReminderButton = props => {
  const isEnabled = (
    (
      !props.guestPermissions ||
      (props.guestPermissions && !props.authentication.isGuest)
    ) &&
    props.parent &&
    props.parent.isProTier());
  if (isEnabled) {
    return (
      <NewButton onClick={props.action} disableRipple>
        REMINDERS
      </NewButton>
    );
  }

  return (
    <NewLockedButton onClick={props.parent.openPopup} disableRipple>
      <Lock />
      REMINDERS
    </NewLockedButton>
  );
};

const PipelineActiveDealDetailsHeader = props => (
  <Container>
    <AddEditAlert
      key={props.dealId}
      dealId={props.dealId}
      isPipelineDeal
      notificationId={0}
      isOpen={props.addEditAlertIsOpen}
      handleCancel={props.handleCancel}
      handleSave={props.handleSave}
      isAlert={props.isAlert}
      isNew
    />
    <Grid container direction="row" justify="flex-start" alignItems="center" spacing={8}>
      <Grid item lg={8} md={8}>
        <Grid container direction="row" justify="flex-start" alignItems="center" spacing={8}>
          <Grid item><div className="title-component">{props.title || "Deal Details"}</div></Grid>
          {props.isEditing ? (<>
            <Grid item><CancelButton onClick={props.cancel} disableRipple /></Grid>
            <Grid item><VerticalDivider /></Grid>
            <Grid item><SaveButton onClick={props.save} disableRipple /></Grid>
                              </>
          ) :
            (
              <>
                {(!props.authentication.isGuest || (props.authentication.isGuest && props.guestPermissions.canEditDeal)) &&
                  <Grid item>
                    <EditButton onClick={props.editDeal} disableRipple />
                  </Grid>}
                {props.includeAlertButtons && (
                  <>
                    <Grid item><AddAlertButton guestPermissions={props.guestPermissions} authentication={props.authentication} parent={props.parent} dealId={props.dealId} action={props.addAlert} /></Grid>
                    <Grid item><VerticalDivider /></Grid>
                    <Grid item><SetReminderButton guestPermissions={props.guestPermissions} authentication={props.authentication} parent={props.parent} dealId={props.dealId} action={props.setReminder} /></Grid>
                  </>
                )}
                {props.optionalCashflows}
                {props.shouldShowChangeStatusButton &&
                  <>
                    <VerticalDivider />
                    <BlueButton onClick={props.onChangeStatusClick}>
                      CHANGE STATUS
                    </BlueButton>
                  </>}
              </>
            )}
        </Grid>
      </Grid>
      <Grid item lg={4} md={4}>
        <NoteAttachmentContainer container direction="row" justify="flex-start" alignItems="center" spacing={0}>
          {props.showNotesAttachmentsLinks ?
            (
              <>
                {(!props.authentication.isGuest || props.guestStore.activeGuest.pipelineProjections) && <>
                  <Grid item>
                    <a href={`/projections/${props.dealId}/true`}>
                      <BlueButton>
                        <Apps />
                        PROJECTIONS
                      </BlueButton>
                    </a>
                  </Grid>
                  <Grid item><VerticalDivider /></Grid>
                                                                                                        </>}
                <Grid item><NotesButton onClick={props.openNotes} disableRipple /></Grid>
                <Grid item><VerticalDivider /></Grid>
                <Grid item><AttachmentsButton onClick={props.openAttachments} disableRipple /></Grid>
              </>
            ) : null}
        </NoteAttachmentContainer>
      </Grid>
    </Grid>
  </Container>
);

export default PipelineActiveDealDetailsHeader;
